import { render, staticRenderFns } from "./TaskOverview.vue?vue&type=template&id=2dc75c40"
import script from "./TaskOverview.vue?vue&type=script&lang=js"
export * from "./TaskOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dc75c40')) {
      api.createRecord('2dc75c40', component.options)
    } else {
      api.reload('2dc75c40', component.options)
    }
    module.hot.accept("./TaskOverview.vue?vue&type=template&id=2dc75c40", function () {
      api.rerender('2dc75c40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Task/TaskOverview.vue"
export default component.exports